import React, { Component } from 'react';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import MenuIcon from '@material-ui/icons/Menu';

const SortableItem = SortableElement(({ value, desc }) => (
  <li className="reserveline-body">
    <div tabIndex={0} style={{ display: 'flex' }}>
      <div className='drag-icon'><MenuIcon/></div>
      <div>
        <div className='reserveline-order'>{value}</div>
      </div>
      <div>
        <div className='data reserveline-desc'>{desc}</div>
      </div>
    </div>
  </li>
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className='reserveline-list'>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.name}`} index={index} value={value.name} desc={value.description} />
      ))}
    </ul>
  );
});

class ReserveItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reserveLineList: props.reserveLineData,
      isSubmitted: props.isSubmitted,
      isSorted: false
    };
  }
  resetList = (nextProps) => {
    if (nextProps.closeClicked || (this.state.isSorted && this.state.isSubmitted && this.props.isReserveLineTypeSaveFailed))
      this.setState({ reserveLineList: nextProps.originalData, isSorted: false })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.originalData !== this.state.reserveLineList) {
      this.setState({ isSorted: true })
    }
    this.setState({ isSubmitted: nextProps.isSubmitted }, () => {
      this.resetList(nextProps);
    });

  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      reserveLineList: arrayMove(this.state.reserveLineList, oldIndex, newIndex),
      isSorted: true
    }, () => {
      this.props.sortedReserveLine(this.state.reserveLineList)
    })
  };
  render() {
    return <SortableList items={this.state.reserveLineList} onSortEnd={this.onSortEnd} />;
  }
}

export default ReserveItem;
